import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: '100%',
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
      minHeight: 360,
      overflow: 'unset',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  header: {
    fontFamily: 'Playfair Display',
    textAlign: 'center',
    fontSize: 30,
    fontWeight: 'bold',
    [theme.breakpoints.up('mobile')]: {
      fontSize: 48,
    },
  },
  description: {
    textAlign: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/components/SurveyPage/components/Survey/useStyles.js